import { useLocation } from 'react-router-dom'
import { z } from 'zod'

const TimelineHashTypeSchema = z.enum([
  'comment',
  'action',
  'event',
  'agent-run',
])

const TimelineHashSchema = z.templateLiteral([
  z.literal('#'),
  TimelineHashTypeSchema,
  z.literal('-'),
  z.uuid(),
])

export type TTimelineHash = z.infer<typeof TimelineHashSchema>
export type TTimelineHashType = z.infer<typeof TimelineHashTypeSchema>

export interface TParsedTimelineHash {
  id: string
  type: TTimelineHashType
}

const TIMELINE_HASH_TYPES_BY_PREFIX_LENGTH = [
  ...TimelineHashTypeSchema.options,
].sort((left, right) => {
  return right.length - left.length
})

export function getTimelineEventHash({
  id,
  type,
}: TParsedTimelineHash): TTimelineHash {
  return `#${type}-${id}`
}

export function parseTimelineEventHash(
  hash: string,
): TParsedTimelineHash | null {
  for (const type of TIMELINE_HASH_TYPES_BY_PREFIX_LENGTH) {
    const prefix = `#${type}-`
    if (hash.startsWith(prefix)) {
      const id = hash.slice(prefix.length)
      if (!TimelineHashSchema.validate(`${prefix}${id}`)) {
        return null
      }

      return { id, type }
    }
  }

  return null
}

export function useHashTimelineId() {
  const location = useLocation()
  return parseTimelineEventHash(location.hash)
}
